import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {
  LogCallComponent,
  LogCallTicketComponent,
  LogCallTimeComponent,
  LogCallRepostComponent
} from '.';
const routes: Routes = [
  {
    path: '',
    component: LogCallComponent,
    children: [
      {
        path: '',
        redirectTo: 'time',
        pathMatch: 'full'
      },
      {
        path: 'time',
        component: LogCallTimeComponent
      },
      {
        path: 'ticket',
        component: LogCallTicketComponent
      },
      {
        path: 'report',
        component: LogCallRepostComponent
      }
    ]
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule
  ]
})
export class LogCallRoutingModule { }
